import { render, staticRenderFns } from "./color-select.vue?vue&type=template&id=80243c02&"
import script from "./color-select.vue?vue&type=script&lang=js&"
export * from "./color-select.vue?vue&type=script&lang=js&"
import style0 from "./color-select.vue?vue&type=style&index=0&id=80243c02&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80243c02')) {
      api.createRecord('80243c02', component.options)
    } else {
      api.reload('80243c02', component.options)
    }
    module.hot.accept("./color-select.vue?vue&type=template&id=80243c02&", function () {
      api.rerender('80243c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/color-select.vue"
export default component.exports